import { checkUserSession } from "~/services/gateways/auth.gateway";

export interface SessionGuardProps {
  interval?: number | null; // intervalo em milissegundos para checar a sessão do usuário (verifica no localstorage quando foi a ultima requisição) e só chama se o intervalo estiver expirado
}

export const useSessionGuard = ({ interval = null }: SessionGuardProps = {}) => {

  const checkSession = async (): Promise<boolean> => {
    // Se não há intervalo definido, sempre chama checkUserSession
    if (!interval) {
      return await checkUserSession();
    }

    // Verifica quando foi a última requisição ao /auth_guard
    const lastAuthGuardRequest = localStorage.getItem("last_auth_guard_request");
    const now = new Date().getTime();

    // Se nunca foi feita uma requisição, faz agora
    if (!lastAuthGuardRequest) {
      return await checkUserSession();
    }

    // Calcula o tempo decorrido desde a última requisição (em milissegundos)
    const timeSinceLastRequest = now - parseInt(lastAuthGuardRequest);

    // Só chama checkUserSession se o intervalo já expirou
    if (timeSinceLastRequest >= interval) {
      return await checkUserSession();
    }

    return true;
  };

  const checkSessionBeforeAction = async (): Promise<boolean> => {
    return await checkSession();
  };

  return { checkSessionBeforeAction };
};

